// extracted by mini-css-extract-plugin
export default {"root":"video_category_root__XwsyR","carousel":"video_category_carousel__WH5S4","title":"video_category_title__79+3c"};